import React from "react";

var rtl = localStorage.getItem("lng") === "ar" ? "rtl" : "ltr"; //document.getElementsByTagName('html')[0].getAttribute('dir');
const withDirection = (Component) => (props) => {
  return <Component {...props} data-rtl={rtl} />;
};

export default withDirection;
export { rtl };
